export const colors = {
  primary: 'var(--voyager-color-primary, #85A2AA)',
  secondary: 'var(--voyager-color-secondary, #455B61)',
  tertiary: 'var(--voyager-color-tertiary, #B5D3DC)',

  fontPrimary: 'var(--voyager-color-fontPrimary, #444444)',
  fontSecondary: 'var(--voyager-color-fontSecondary, #666666)',

  navigationAndFooter: 'var(--voyager-color-navigationAndFooter, #333333)',
  header: 'var(--voyager-color-header, #F4F4F4)',
  sectionTitle: 'var(--voyager-color-sectionTitle, #919191)',
  borderGrey: 'var(--voyager-color-borderGrey, #E0E0E0)',
  borderGreyLighter: 'var(--voyager-color-borderGreyLighter, #EFEFEF)',

  darkGrey: 'var(--voyager-color-darkGrey, #646464)',
  grey: 'var(--voyager-color-grey, #C1C1C1)',
  lightGrey: 'var(--voyager-color-lightGrey, #E2E2E2)',
  lighterGrey: 'var(--voyager-color-lighterGrey, #F7F7F7)',
  error: 'var(--voyager-color-error, #E55646)',
  errorBackground: 'var(--voyager-color-errorBackground, #FDEEEB)',
  success: 'var(--voyager-color-success, #009688)',
  successBackground: 'var(--voyager-color-successBackground, #E5F4F3)',
  info: 'var(--voyager-color-info, #01579B)',
  infoBackground: 'var(--voyager-color-infoBackground, #E6EEF5)',
  black: 'var(--voyager-color-black, #000000)',
  white: 'var(--voyager-color-white, #FFFFFF)',
  offWhite: 'var(--voyager-color-offWhite, #f1f1f1)',
  sale: 'var(--voyager-color-sale, #E2363F)',
} as const;

export const space = {
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '24px',
  6: '32px',
  7: '48px',
  8: '64px',
  9: '80px',
  10: '96px',
} as const;

export const fonts = {
  heading: "var(--voyager-heading-font, 'Playfair Display', serif)",
  body: "var(--voyager-body-font, 'Open Sans', sans-serif)",
  baseSize: '16px',
  size: {
    xxs: '0.5625rem', // 9px
    xs: '0.8125rem', // 13px
    sm: '0.875rem', // 14px
    md: '0.9375rem', // 15px
    base: '1rem', // 16px
    lg: '1.25rem', // 20px
    xl: '1.5rem', // 24px
    '2xl': '1.75rem', // 28px
    '3xl': '2.5rem', // 40px
    '4xl': '3rem', // 48px
  },
  weight: {
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
} as const;

export const headingFont = fonts.heading;
export const bodyFont = fonts.body;

export const layout = {
  maxWidth: '1480px',
  horizontalPadding: '20px',
  headerHeightMobile: '81px',
  headerHeightDesktop: '111px',
  desktopBreakpoint: '769px',
  borderRadius: '3px',
  borderRadiusMd: '8px',
  borderRadiusLg: '12px',
  borderRadiusXl: '16px',
  zIndexModal: 10000,
  modalWidth: '420px',
  overlay: 'rgba(0, 0, 0, 0.4)',
  shadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
} as const;

export const colorVarNames = {
  primary: '--voyager-color-primary',
  secondary: '--voyager-color-secondary',
  tertiary: '--voyager-color-tertiary',
  fontPrimary: '--voyager-color-fontPrimary',
  fontSecondary: '--voyager-color-fontSecondary',
  navigationAndFooter: '--voyager-color-navigationAndFooter',
  header: '--voyager-color-header',
  sectionTitle: '--voyager-color-sectionTitle',
  borderGrey: '--voyager-color-borderGrey',
  borderGreyLighter: '--voyager-color-borderGreyLighter',
  darkGrey: '--voyager-color-darkGrey',
  grey: '--voyager-color-grey',
  lightGrey: '--voyager-color-lightGrey',
  lighterGrey: '--voyager-color-lighterGrey',
  error: '--voyager-color-error',
  errorBackground: '--voyager-color-errorBackground',
  success: '--voyager-color-success',
  successBackground: '--voyager-color-successBackground',
  info: '--voyager-color-info',
  infoBackground: '--voyager-color-infoBackground',
  black: '--voyager-color-black',
  white: '--voyager-color-white',
  offWhite: '--voyager-color-offWhite',
  sale: '--voyager-color-sale',
} as const;

export const fontVarNames = {
  heading: '--voyager-heading-font',
  body: '--voyager-body-font',
} as const;
